import {Component, Fragment, h} from "preact";
import {C, FR, E, R} from "../../_common/layout";
import {connect} from "react-redux";
import {fetchApplications, fetchCandidatesCount, fetchCompanyOffersApplicationsFilter} from "../../_rx/jobs/actions";
import ApplicationCard from "./applicationCard";
import {AcademicProgram} from "../../_api";
import {ModalLink} from "../../_common/components/modal";
import OrderButton from './orderButton';
import {rndStr} from "../../_common/common";
import ModalFilter from "./modalFilter";

const orderType: {[key:number]:any} = {
    0: 'killer-grade',
    1: 'finished',
    2: 'inscription',
    3: 'surname'
}

type props = {
    tab: string,
    id: number,
    fetchApplications: typeof fetchApplications,
    fetchCompanyOffersApplicationsFilter: typeof fetchCompanyOffersApplicationsFilter,
    rest: any,
    offerReducer: any,
    companyCandidatesCount: any,
    companyOffersApplicationFilter: any,
    fetchCandidatesCount: typeof fetchCandidatesCount,
    fixtures: {academic_programs: AcademicProgram[]}
}

type state = {
    idModal: string,
    orderSelected: string,
    filterValues: any
}

class Applications extends Component<props, state> {

    constructor(props: props) {
        super(props);
        this.state = {
            idModal: rndStr(),
            orderSelected: orderType[2],
            filterValues: {}
        }
    }

     async componentDidMount() {
         await this.props.fetchApplications({id: this.props.id, status: this.props.tab, order: orderType[2]});
         if (!this.props.companyCandidatesCount)
             await this.props.fetchCandidatesCount({id: this.props.id, status: this.props.tab});
         if(!this.props.companyOffersApplicationFilter)
             await this.props.fetchCompanyOffersApplicationsFilter({id: this.props.id, status: this.props.tab});
     }

     async componentDidUpdate(previousProps: Readonly<props>, previousState: Readonly<{}>, snapshot: any) {
        if (previousProps.tab !== this.props.tab){
            await this.props.fetchCompanyOffersApplicationsFilter({id: this.props.id, status: this.props.tab});
            await this.props.fetchApplications({id: this.props.id, status: this.props.tab});
            await this.props.fetchCandidatesCount({id: this.props.id, status: this.props.tab})
        }
    }

    changeOrder = (key: number) => {
        this.setState({orderSelected: orderType[key]})
        this.props.fetchApplications({
            id: this.props.id,
            status: this.props.tab,
            order: orderType[key],
            ...this.state.filterValues
        })

    }

    changeFilter = (filterValues: any) =>{
        this.setState({filterValues: filterValues})
        this.props.fetchApplications({
            id: this.props.id,
            status: this.props.tab,
            order: this.state.orderSelected,
            ...filterValues
        })
    }

    render ({companyCandidatesCount, companyOffersApplicationFilter}: props) {
        if(!companyOffersApplicationFilter || !companyCandidatesCount) return null;
        return <Fragment>
            <FR >
                <E className='col-50 flex-center-y'>
                    <R className='cursor-pointer'>
                        <OrderButton id={this.props.id} status={this.props.tab}
                                     onClick={(key: number) => this.changeOrder(key)}/>
                    </R>
                </E>
                {companyOffersApplicationFilter.showGeneral && <E className='col-50 flex-right d-flex flex-center-y'>
                    <div className='cursor-pointer'>
                        <ModalLink id={this.state.idModal}><span className='t-upper'>Filtrar</span></ModalLink>
                        {(this.state.filterValues !== null && Object.keys(this.state.filterValues).length !== 0) &&
                        <span
                            className="m-l-half sm-m-l-half">{"(" + Object.values(this.state.filterValues).join(",").split(",").length + ")"}</span>}
                        <i className="fal fa-sliders-h p-left" aria-hidden="true"/>
                        <ModalFilter id={this.state.idModal} idOffer={this.props.id} tab={this.props.tab}
                                     companyCandidatesCount={companyCandidatesCount}
                                     companyOffersApplicationFilter={companyOffersApplicationFilter}
                                     onClick={(filterValues: any) => this.changeFilter(filterValues)}/>
                    </div>
                </E>
                }
            </FR>
            <C className='max-width-980'>
                {(this.props.offerReducer.applications) &&
                this.props.offerReducer.applications.map((apply: object) => <ApplicationCard apply={apply}
                                                                                             fixtures={this.props.fixtures}
                                                                                             acceptUnfinished={this.props.offerReducer.offerSelected.acceptUnfinished}/>)}
            </C>
        </Fragment>;
    }
}

const ConnectedView: any = connect(
    ({offerReducer, fixtures, companyOffersApplicationFilter, companyCandidatesCount}:any)=>({offerReducer, fixtures, companyOffersApplicationFilter, companyCandidatesCount}), {fetchApplications, fetchCompanyOffersApplicationsFilter, fetchCandidatesCount})(Applications as any);


export default ({ id, tab}: {id: number, tab: string}) =>
    <ConnectedView id={id} tab={tab}/>
;
